const importResidents = async (columns, rows) => {
  return $.ajax({
    url: `/api/v1/resident_import/import`,
    method: "POST",
    data: {
      columns,
      rows,
    },
    success: (data) => {
      return data;
    },
  });
};

export default importResidents;
